import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "error-toast" }
const _hoisted_2 = { class: "error-toast__body" }
const _hoisted_3 = { class: "error-toast__title" }
const _hoisted_4 = { class: "error-toast__message" }
const _hoisted_5 = ["title"]

import { ref } from 'vue';
    import { toast } from 'vue3-toastify';
    import { i18n } from '@/utilities/i18n';

    interface Props {
        message: string;
        errorId?: string;
        severity?: 'error' | 'warning';
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorToast',
  props: {
    message: {},
    errorId: {},
    severity: {}
  },
  setup(__props: any) {

    const props = __props;
    const t = i18n.global.t;
    const copied = ref(false);

    const copyToClipboard = async (text: string): Promise<void> => {
        try {
            await navigator.clipboard.writeText(text);
        } catch {
            const el = document.createElement('textarea');
            el.value = text;
            el.style.position = 'fixed';
            el.style.opacity = '0';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        }
    };

    const onCopy = async () => {
        if (!props.errorId) return;
        await copyToClipboard(`id : ${props.errorId}`);
        copied.value = true;
        toast.success(t('errorToast.copySuccess'), { autoClose: 2000 });
        setTimeout(() => {
            copied.value = false;
        }, 2000);
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.severity === 'warning' ? _unref(t)('generic.warning') : _unref(t)('generic.error')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.message), 1),
      (__props.errorId)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: _normalizeClass(['error-toast__id-pill', { 'error-toast__id-pill--copied': copied.value }]),
            title: copied.value ? _unref(t)('errorToast.copied') : _unref(t)('errorToast.copyId'),
            onClick: onCopy
          }, _toDisplayString(copied.value ? `✓ ${_unref(t)('errorToast.copied')}` : `ID: ${__props.errorId}`), 11, _hoisted_5))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})